<footer class="container-fluid">
  <ul>
    <li>
      <a [routerLink]="''">{{ "home" | translate }}</a>
    </li>
    <li>
      <a [routerLink]="'/about-us'">{{ "about us" | translate }}</a>
    </li>
    <li>
      <a [routerLink]="'/products'">{{ "products" | translate }}</a>
    </li>

    <li>
      <a [routerLink]="'/contact-us'">{{ "contact us" | translate }}</a>
    </li>
  </ul>

  <div class="follow">
    <h3>
      {{ "follow us" | translate }}
    </h3>

    <a
      href="{{ contactUsData?.facebook }}"
      title="{{ contactUsData?.facebook }}"
      target="_blank"
    >
      <img src="assets/facebook.png" alt="facebook" />
    </a>

    <img src="assets/insta.png" alt="" />
    <img src="assets/twitter.png" alt="" />
  </div>

  <div class="row">
    <p class="col-md-9 col-xs-12">
      {{ "New Furniture | privacy policy" | translate }}
    </p>

    <p class="col-md-3 col-xs-12 text-left">
      {{ "Developed by" | translate }}
      <a href="https://www.developnetwork.net/en/" class="lnk"
        >DevelopNetwork</a
      >
    </p>
  </div>
</footer>
